var render = function render(_c,_vm){return _c('div',{staticClass:"whitespace-pre-line text-base",domProps:{"innerHTML":_vm._s(_vm.props.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }